import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

export default function PaymentResult({ status }) {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const next = sp.get("next");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (status !== "success" || !sid) { setState(status); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      setAttempts(tries);
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          await refresh();
          setState("paid");
          if (next && next.startsWith("/")) setTimeout(() => navigate(next), 1500);
          return;
        }
      } catch {}
      if (tries < 12) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    // eslint-disable-next-line
  }, [sid]);

  if (status === "cancel") {
    return (
      <div className="max-w-md mx-auto px-5 pt-16 text-center">
        <h1 className="font-display text-3xl font-black">Checkout canceled.</h1>
        <p className="text-gray-400 mt-2">No charge. You can try again anytime.</p>
        <Link to="/pro" className="mt-6 inline-block hero-accent text-white font-bold px-6 py-3 rounded" data-testid="try-again">Back to plans</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-5 pt-16 text-center">
      {state === "polling" && <><h1 className="font-display text-3xl font-black">Confirming payment…</h1><p className="text-gray-400 mt-2">Attempt {attempts}/12</p></>}
      {state === "paid" && <>
        <div className="eyebrow text-[#FD0F10]">YOU'RE IN</div>
        <h1 className="font-display text-4xl font-black mt-2">Pro unlocked.</h1>
        <p className="text-gray-400 mt-2">Every path. Every guide. Your Coach.</p>
        {next ? <p className="text-gray-400 mt-4" data-testid="returning-to-coach">Taking you back to your coach…</p>
          : <Link to="/dashboard" className="mt-6 inline-block hero-accent text-white font-bold px-6 py-3 rounded" data-testid="go-dashboard">GO TO DASHBOARD →</Link>}
      </>}
      {state === "timeout" && <><h1 className="font-display text-3xl font-black">Still processing.</h1><p className="text-gray-400 mt-2">Payment may take a minute. Refresh Dashboard in a bit.</p></>}
    </div>
  );
}
